require("./visualMapContinuous");

require("./visualMapPiecewise");